var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"chat-card"},[_c('div',{staticClass:"all-btn"},_vm._l((_vm.cardData.data),function(item,index){return _c('div',{key:index,staticClass:"item-btn",on:{"click":function($event){return _vm.submitFn(item.text, item?.reply)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }